import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import FaqSection from './components/FaqSection';
import CardsSection from './components/CardsSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <AppSection />
        <FaqSection />
        <CardsSection />
        <CarouselSection />
        <UpdatesSection />
        <RankingSection />
        <TopicsSection />
        <CommentsSection />
        <IndexSection />
        <ContactSection />
        <AboutSection />
        <FeaturesSection />
      </main>
      <Footer />
    </>
  );
}